export async function clearIndexedDB() {
    const deleted = [];
    const idb = indexedDB;
    if (typeof idb.databases === "function") {
        const dbs = await idb.databases();
        for (const db of dbs) {
            const name = db.name || undefined;
            if (!name)
                continue;
            await new Promise((resolve, reject) => {
                const req = indexedDB.deleteDatabase(name);
                req.onsuccess = () => resolve();
                req.onblocked = () => resolve();
                req.onerror = () => reject(req.error);
            });
            deleted.push(name);
        }
    }
    else {
        const fallbackNames = ["keyval-store", "localforage"];
        for (const name of fallbackNames) {
            await new Promise((resolve) => {
                const req = indexedDB.deleteDatabase(name);
                req.onsuccess = () => resolve();
                req.onblocked = () => resolve();
                req.onerror = () => resolve();
            });
            deleted.push(name);
        }
    }
    return deleted;
}
//# sourceMappingURL=clearIndexedDB.js.map